import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const MyCarSelect = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>등록하려는 내 차를 선택하세요.</h3>
				<p className="guide-title mt_20">조회된 차를 선택하거나 차량번호를 직접 입력해 내 차를<br />등록할 수 있어요.</p>

				<div className={`${styles["choose-group"]} mt_40`}>
					<div>
						<span>차량번호</span>
						<div className="mt_5">서울12가1234</div>
					</div>
					<div>
						<span>차량번호</span>
						<div className="mt_5">123가1234</div>
					</div>
					<div>
						<span>차대번호</span>
						<div className="mt_5">KG5977782D11242</div>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">차량번호 직접 입력하기</Button>
			</div>
		</div>
	)
}

export default MyCarSelect